<template>
  <div class="modal" data-backdrop="static" id="bsShareFormDialog" ref="bsShareFormDialogRef">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <form id="saveShare" name="saveShare"
              :action="pUrls['saveShare']"
              method="post" class="ajax-support show-waiting"
              data-ajax-support-csv="#ajaxModuleForm,#popoverShareList">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title">{{ title }}</h3>
          </div>
          <div class="modal-body max-height bs3-padding-top-reset bs3-padding-bottom-reset">
            <input type="hidden" name="dataForm.data.id" :value="data.id"/>
            <input type="hidden" name="dataForm.data.projectRef.id" :value="data.projectRef.id"/>
            <input type="hidden" name="src" :value="pSrc"/>
            <input type="hidden" name="srcId" :value="pSrcId"/>
            <div v-if="nbOfErrors > 0">
              <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
              </div>
            </div>
            <div class="bs3-padding-y">
              <div class="row">
                <div class="col-xs-12">
                  <share-save-form-recipient-add
                      :p-currencies="pCurrencies"
                      :p-language="pLanguage"
                      :p-dictionary="pDictionary"
                      :p-error-list="pErrorList"
                      :p-project-id="data.projectRef.id"
                      @share-recipient-added="onAddRecipient">
                  </share-save-form-recipient-add>
                  <ul class="list-group bs3-margin-top" v-show="recipients.length > 0">
                    <share-save-form-recipient-list
                        v-for="(recipient, index) in recipients"
                        :key="recipientKey(recipient, index)"
                        :p-currencies="pCurrencies"
                        :p-language="pLanguage"
                        :p-dictionary="pDictionary"
                        :p-error-list="pErrorList"
                        :p-index="index"
                        :p-recipient="recipient"
                        @share-recipient-removed="onRemoveRecipient">
                    </share-save-form-recipient-list>
                    <li class="list-group-item" v-show="recipients.length === 0">
                      <span class="emptyOrNull">{{pDictionary['dictionary.general.none']}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-xs-12 text-right">
              <button type="submit" :disabled="buttonsDisabled" class="btn btn-primary">
                <i class="fa-light fa-check"></i> {{ pDictionary['dictionary.actions.share'] }}
              </button>
              <a href="#" class="btn btn-link" data-dismiss="modal" aria-label="Cancel">
                {{ pDictionary['dictionary.actions.cancel'] }}
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import stringhelpers from "@/helpers/string-helpers";
import ShareSaveFormRecipientAdd from "@/components/common/share/form/save/ShareSaveFormRecipientAdd";
import ShareSaveFormRecipientList from "@/components/common/share/form/save/ShareSaveFormRecipientList";

export default {
  name: "ShareSaveForm",
  components: {ShareSaveFormRecipientList, ShareSaveFormRecipientAdd},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data,
      recipients: this.pDataForm.recipients,
      errorList: []
    }
  },
  methods: {
    isIdValid: function () {
      return this.data.id !== undefined
             && this.data.id > 0;
    },
    recipientKey: function(recipient, index) {
      return recipient.email + index;
    },
    onAddRecipient: function(recipient) {
      let _component = this;
      _component.recipients.push(recipient);
      _component.errorList.push({});
    },
    onRemoveRecipient: function(index) {
      this.recipients.splice(index, 1);
      this.errorList.splice(index, 1);
    }
  },
  computed: {
    title: function () {
      return !this.isIdValid()
             ? stringhelpers.formatI18nParams(this.pDictionary['dictionary.share.create.title'], 0, this.data.projectRef.name)
             : this.pDictionary['dictionary.share.update.title'];
    },
    buttonsDisabled: function() {
      return this.recipients.length === 0;
    }
  },
  mounted: function () {
    let _component = this;

    let $bsShareFormDialog = $(_component.$refs.bsShareFormDialogRef);
    $bsShareFormDialog.on('shown.bs.modal', function () {

    });

    $bsShareFormDialog.on('hidden.bs.modal', function () {
 
    });

    $bsShareFormDialog.modal();
  }
}
</script>

<style scoped>

</style>